// src/Constants.js

const ENV_CONFIGS = {
    development: 'http://localhost:8080/api',
    staging: 'https://api-internal-staging.morrisisc.com/api',
    uat: 'https://api-uat.morrisisc.com/api',
    preproduction: 'https://api-pre-prod.morrisisc.com/api',
    production: 'https://filemule-internal-api-c7cvhdarhxcqexgr.centralus-01.azurewebsites.net/api',
};

function getConfig(env){
    if (!env) return ENV_CONFIGS.development;
    return ENV_CONFIGS[env.toLowerCase()] || ENV_CONFIGS.development;
};

export const config = getConfig(process.env.REACT_APP_ENV);


const LicensingPortalConfig = {
    development: 'https://licensing.morrisisc.com',
    staging: 'https://licensing-ui-staging-gsc6affuhadnf3at.centralus-01.azurewebsites.net',
    uat: 'https://licensing-ui-uat-fmfwa9ezfwc8gtcp.centralus-01.azurewebsites.net',
    preproduction: 'https://licensing.morrisisc.com',
    production: 'https://licensing.morrisisc.com',
};
export const LicensingPortalUrl = LicensingPortalConfig[process.env.REACT_APP_ENV?.toLowerCase() || 'development'];

export const BaseStateInformationPortalUrl = 'https://netorg134974.sharepoint.com/StateInfo/State%20Information';
export const StateInformationPortalUrl = `${BaseStateInformationPortalUrl}/Home.aspx`;

export const MuiLicenseKey = '151fe47fa698051d15a6beffa5661eadTz0xMTUwOTcsRT0xNzgyMzQ1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';

